/*global GridController*/

var TrackedSmsEventEmbeddable = function(options){    
    GridController.call(this,"iz_tracked_sms_event", 
    {
        directory: "views/tracked",
        name: "trackedSmsEventGrid"
    }) ;

    /**
     * This is called when the embeddable is loaded with data (typically a view render)
     * 
     * @param {object} data the data given to the embedded instance (for example : the customer)
    */
    this.prepareDataOnEnter = function(data, callback){
        if(data && options && options.searchfield){
            //if we receive some data, we update the grid search options with a new
            //search criteria
            //the this.options object will be filled from HTML markup
            this.searchOptions = {} ;
            this.searchOptions[options.searchfield] = data.id ;
        }
        //call the normal function on the grid super class to continue with standard grid behavior
        GridController.prototype.prepareDataOnEnter.call(this, data, callback) ;
    } ;
} ;

TrackedSmsEventEmbeddable.prototype = Object.create(GridController.prototype);
TrackedSmsEventEmbeddable.prototype.constructor = TrackedSmsEventEmbeddable;

module.exports = TrackedSmsEventEmbeddable ;